import React from "react";
import { Link } from "react-router-dom";
import {
  LayoutDashboard,
  LogIn,
  LogOut,
  User,
  UserPlus,
} from "lucide-react";

export const getAccountInitial = (user) =>
  (user?.name?.[0] || user?.email?.[0] || "?").toUpperCase();

const AccountProfileMenuItem = ({ to, Icon, label, onClose }) => (
  <Link
    to={to}
    onClick={onClose}
    role="menuitem"
    className="app-deck-menu-item"
  >
    <Icon size={15} strokeWidth={2} />
    <span>{label}</span>
  </Link>
);

const AccountProfileMenu = React.forwardRef(({
  user,
  isAuthenticated,
  onSignOut,
  onClose,
  className = "",
  style,
}, ref) => (
  <div
    ref={ref}
    role="menu"
    className={["app-deck-menu", className].filter(Boolean).join(" ")}
    style={style}
  >
    {isAuthenticated ? (
      <>
        <div className="app-deck-menu-head">
          <div className="app-deck-menu-name">{user?.name || "Account"}</div>
          <div className="app-deck-menu-email">{user?.email}</div>
        </div>
        <AccountProfileMenuItem
          to="/app/dashboard"
          Icon={LayoutDashboard}
          label="Dashboard"
          onClose={onClose}
        />
        <AccountProfileMenuItem
          to="/app/profile"
          Icon={User}
          label="Profile"
          onClose={onClose}
        />
        <div className="app-deck-menu-divider" />
        <button
          type="button"
          className="app-deck-menu-signout"
          onClick={onSignOut}
        >
          <LogOut size={14} /> Sign out
        </button>
      </>
    ) : (
      <>
        <AccountProfileMenuItem
          to="/app/login"
          Icon={LogIn}
          label="Log in"
          onClose={onClose}
        />
        <AccountProfileMenuItem
          to="/app/signup"
          Icon={UserPlus}
          label="Create account"
          onClose={onClose}
        />
      </>
    )}
  </div>
));

AccountProfileMenu.displayName = "AccountProfileMenu";

export default AccountProfileMenu;
